module.exports = __webpack_public_path__ + "static/img/team_honor.1c78f73a.png";